import apiReq from '../commontools/api.js'
export function GetCorpValid(){
	var url='/Corp/GetCorpValid';
	return apiReq.get(url);
}
export function GetAllCorp(){
	var url='/Corp/GetAllCorp';
	return apiReq.get(url);
}
export function AddCorp(info){
	var url='/Corp/AddCorp';
	var p={
		data:info
	}
	return apiReq.post(url,p);
}
export function EditCorp(info){
	var url='/Corp/EditCorp';
	var p={
		data:info
	}
	return apiReq.post(url,p);
}
export default{
	GetCorpValid,
	GetAllCorp,
	AddCorp,
	EditCorp
	
}